<template>
  <CustomerAppt :customer="customer" v-if="customer" />
</template>

<script>
import CustomerAppt from "@/views/Components/Appt/NewApptWizard/CustomerAppt.vue";
export default {
  components: { CustomerAppt },
  props: { customer: null },
};
</script>

<style></style>
